enum WebSocketConnectionStatus {
  CONNECTED,
  DISCONNECTED,
}

export default WebSocketConnectionStatus;
